export const chatConfig = {
  fileLayout: 'sm',
  icons: {
    loader: 'spinner-third',
    new_message_indicator: 'chevron-down',
    message_deleted: 'ban',
    retry: 'arrow-rotate-right',
    dismiss: 'xmark',
    official_representative: 'shield-check',
    new_message_indicator_up: 'chevron-up',
    mark_all_as_read: 'check-double',

    states: {
      initialized: 'clock',
      sending: 'clock',
      sent: 'check',
      persisted: 'check',
      final_seen: 'check',
      error: 'exclamation-triangle',
    },

    menu: {
      info: 'info-circle',
      copy: 'copy',
      visit_profile: 'user',
      edit: 'pencil',
      restore: 'trash-restore-alt',
      delete: 'trash-alt',
      reply: 'reply',
    },

    form: {
      attachment: 'plus-circle',
      send: 'send',
      exit_edit_mode: 'solid:close',
      remove_file: 'close',
    },
  },
  menu: {
    infoOn: false,
  },
  avatar: {
    disableInitials: false,
  },
  truncateMaxLines: 10,
};
